<ng-container *ngFor="let item of breadcrumbs; let last = last">
  <span class="breadcrumb" 
    [ngClass]="{active: last}" 
    (click)="openBreadCrumb(item, last)">
    {{ item.label | translate }}
  </span>
  <span class="breadcrumb" *ngIf="!last">
    >
  </span>
</ng-container>